exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom_col1 {\n  width: 4.555%; }\n\n.padding_left0 {\n  padding-left: 0px; }\n\n.padding_right0 {\n  padding-right: 0px; }\n\n.navbar-fixed-left {\n  background-color: black;\n  width: 60px;\n  position: fixed;\n  border-radius: 0;\n  border: none;\n  min-height: 100%;\n  z-index: 1; }\n  .navbar-fixed-left .navbar-nav li {\n    display: inline-block;\n    width: 100%;\n    text-align: center; }\n    .navbar-fixed-left .navbar-nav li.active a {\n      width: 35px;\n      height: 35px;\n      border-radius: 50%;\n      background: #fff;\n      color: #0abe51;\n      display: inline-block;\n      font-size: 16px;\n      line-height: 37px;\n      text-align: center;\n      padding: 0px; }\n    .navbar-fixed-left .navbar-nav li a {\n      font-size: 16px;\n      margin-top: 10px; }\n    .navbar-fixed-left .navbar-nav li :hover {\n      color: #0abe53; }\n\na.disabled {\n  pointer-events: none;\n  cursor: not-allowed; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/navbar/navbar.component.scss
// module id = ./src/app/navbar/navbar.component.scss
// module chunks = main